// import * as agCharts from 'ag-charts-community';
import { AgChartsReact } from "ag-charts-react";

function DeviceOSChart(props) {
  const options = {
    data: props.deviceOS,
    series: [
      {
        type: "pie",
        angleKey: "count",
        labelKey: "osVersion",
      },
    ],
  };
  return (
    <div>
      <h1>Chrome OS versions</h1>
      <AgChartsReact options={options} />
    </div>
  );
}

export default DeviceOSChart;
